import ReducerBuilder from 'classes/ReducerBuilder';
import initialState from './initialState';
import {Types} from "./actions";
import AppContext from "pages/AppContext";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.LOGIN).reduce((state, action) => state)
    .forType(Types.LOGIN_SUCCESS)
    .reduce((state, action) => {
        console.log("login success", action);
        AppContext.persistentStore.setItem("cmsAccessToken", action.accessToken);
        AppContext.persistentStore.setItem("userId", action.user.id);
        state.accessToken = action.accessToken;
        state.loginErrorMessage = null;
        state.user = action.user;
    })
    .forType(Types.LOGIN_FAILED)
    .reduce((state, action) => {
        console.log("login failed", action);
        // TODO: Need error messages from api
        state.loginErrorMessage = "Failed to login with given email/password combination.";
    })
    .forType(Types.LOGOUT).reduce((state, action) => state)
    .forType(Types.LOGOUT_SUCCESS)
    .reduce((state, action) => {
        state.accessToken = null;
        AppContext.persistentStore.removeItem("cmsAccessToken");
        AppContext.persistentStore.removeItem("userId");
    })
    .forType(Types.LOGOUT_FAILED)
    .reduce((state, action) => {
        state.accessToken = null;
        AppContext.persistentStore.removeItem("cmsAccessToken");
        AppContext.persistentStore.removeItem("userId");
    })
    .forType(Types.RESET_PASSWORD)
    .reduce((state, action) => {
    })
    .forType(Types.RESET_PASSWORD_SUCCESS)
    .reduce((state,action) => {
      state.sendSuccess = true;
    })
    .forType(Types.RESET_PASSWORD_FAILED)
    .reduce((state, action) => {
      state.error = action.error;
      state.sendSuccess = false;
    })
    .forType(Types.END_RESET_PASSWORD)
    .reduce((state, action) => {
      state.resettingPassword = false;
    })
    .forType(Types.START_RESET_PASSWORD)
    .reduce((state, action) => {
      state.resettingPassword = true;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/Login/reducer.js